import theme from '../../base';

const textEditor = {
  background: theme.colors.neutrals.white,
  borderBackground: theme.colors.neutrals.gray500,
  foreground: theme.colors.neutrals.gray800,
  placeholder: theme.colors.neutrals.gray700,
  error: theme.colors.reds.red500,
};

export default textEditor;
